import React, { Component } from "react";
import EmbCenso from "./EmbCenso";

export default class PanelCensoEmb extends Component {

  render() {

    const {unidad_medica_user}= this.props;

    return(
      
      unidad_medica_user !== "" &&
        <div className="pnl-censo-emb">
          <div className="pnl-ce-emb-cor">
            <span className="format-titles-pnl">Censo de nuevas pacientes embarazadas (último mes)</span>
              <EmbCenso {...this.props}/>
          </div>
        </div>
    );    
  }
}
